import { SYSTEMS, goToSystem } from "../integration";

/** Tela cheia "Verificando acesso..." enquanto o portão consulta o Portal. */
export function AccessChecking() {
  return (
    <div className="error-state">
      <div className="error-icon">⏳</div>
      <h2>Verificando acesso...</h2>
      <p className="error-msg">Aguarde enquanto confirmamos seu acesso ao Almoxarifado.</p>
    </div>
  );
}

interface DeniedProps {
  /** Usuário atual (levado ao Portal no "Voltar ao Portal"). */
  user: string | null;
  /** true quando a checagem falhou por rede (mensagem diferente). */
  networkError?: boolean;
}

/**
 * Tela cheia de bloqueio: usuário sem acesso a este sistema (ou falha ao
 * verificar). Oferece o retorno ao Portal levando o usuário.
 */
export function AccessDenied({ user, networkError }: DeniedProps) {
  return (
    <div className="error-state">
      <div className="error-icon">{networkError ? "⚠️" : "🔒"}</div>
      <h2>{networkError ? "Não foi possível verificar o acesso" : "Acesso negado"}</h2>
      <p className="error-msg">
        {networkError
          ? "Não foi possível verificar o seu acesso a este sistema. Tente novamente em instantes."
          : "Você não tem acesso a este sistema. Fale com o Admin Supremo."}
      </p>
      <button className="btn-primary" onClick={() => goToSystem(SYSTEMS.portal, user)}>
        Voltar ao Portal
      </button>
    </div>
  );
}
